import {
  BankAccountData,
  ChequePaymentData,
  DebitCardData,
  PaymentAccountDetails,
  VccPaymentData,
} from "../types/paymentTypes";
import { api } from "./api";
import { GET_PAYMENT_METHODS } from "./config";
import { AxiosRequestConfig } from "axios";

const paymentService = {
  getPaymentMethods: (): AxiosRequestConfig => {
    return {
      url: GET_PAYMENT_METHODS,
      method: "GET",
    };
  },
  createVccPayment: async (provider: string): Promise<any> => {
    try {
      const response = await api({
        url: `/v3/payment-methods/vc/${provider}/latest-payment`,
        method: "POST",
        data: {},
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createPayment: (
    data: BankAccountData | ChequePaymentData | VccPaymentData | DebitCardData,
    endpoint: string
  ): AxiosRequestConfig => {
    return {
      url: endpoint,
      method: "POST",
      data: data,
    };
  },

  getVccPaymentVisualise: (provider: string): AxiosRequestConfig => {
    return {
      url: `/v3/payment-methods/vc/${provider}/visualise`,
      method: "GET",
    };
  },

  getTransactions: (): AxiosRequestConfig => {
    return {
      url: `/v3/payments/all`,
      method: "GET",
    };
  },
};

export default paymentService;
